module.exports = __webpack_public_path__ + "static/media/DG8960-ben1.b905644f.png";